import styled from 'styled-components';

import { spaceMixin } from '@zillow/constellation';

export const StyledSearchBoxContainer = styled.div`
    /* override constellation */
    & div[class^="StyledAdornedInput"] {
        height: 42px;

        input  {
            padding: ${spaceMixin('xs')} 0 ${spaceMixin('xs')} ${spaceMixin('sm')};
            font-weight: 400;
        }

        label {
            padding: ${spaceMixin('xs')} ${spaceMixin('sm')};
        }
    }
`;
